// extracted by mini-css-extract-plugin
export default {"imageWrapper":"FF-z","hovered":"GF-z","hoverImage":"HF-z","mainImage":"IF-z","imageNoBackground":"JF-z","fullSizeImage":"KF-z"};